import assest from "@/json/assest";
import Wrapper from "@/layout/wrapper/Wrapper";
import CustomButton from "@/ui/Buttons/CustomButton";
import { Avatar, Grid, List, ListItem, Typography } from "@mui/material";
import { Box, Container, styled } from "@mui/system";
import Image from "next/image";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SlickSliderWrapper from "@/ui/Slick/SlickSliderWrapper";
import WhatPeopleSay from "@/components/WhatPeopleSay/WhatPeopleSay";
import CommonHeaderInner from "@/components/CommonHeaderInner/CommonHeaderInner";
import { Button, Dialog, Paper, TextField, } from '@mui/material';
import Seo from "@/components/Seo/Seo";
import { useState } from "react";
import CancelIcon from '@mui/icons-material/Cancel';
import Link from "next/link";

const AboutSec = styled(Box)`
  .about-inr {
    padding-right: 40px;
    @media (max-width:899px){
      padding-right: 0px;
      margin-bottom: 30px;
}
    .btn-outr {
      margin-top: 25px;
      .MuiTypography-root {
        display: inline-flex;
        align-items: center;
        span {
          margin-right: 24px;
        }
      }
    }
    li {
      margin-bottom: 30px;
      @media (max-width:1199px){
        margin-bottom: 15px;
      }
      &.MuiListItem-root {
        padding: 0;
        background-image: url("/assets/images/tick-grn.svg");
        background-position: center left;
        padding-left: 47px;
        background-repeat: no-repeat;
        background-size: 33px;
      }
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  .about-fig {
    border-radius: 20px;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .about-row {
    align-items: center;
  }
  .about-outr {
    position: relative;

    .blackdot {
      position: absolute;
      right: -100px;
      top: -20px;
      z-index: -1;
      @media (max-width:1400px) {
        right: -20px;
        top: -50px;
        width: 10%;
        margin-left: auto;
        
      }
      @media (max-width:899px){
        display: none;
}
    }
  }
  .about-sec {
    padding-bottom: 100px;
    @media (max-width:1199px){
      padding-bottom: 70px;
    }
    &:nth-child(even) {
      .about-row {
        flex-direction: row-reverse;
        .about-inr {
          padding-right: 0;
          padding-left: 40px;
          @media (max-width:899px){
            padding-left: 0;
          }
        }
      }
      .blackdot {
        right: auto;
        left: -100px;
      }
    }
    &:last-child {
      padding-bottom: 0px;
    }
  }
`;
const EnqueryDialog = styled(Box)`
    text-align: center;

    .MuiTypography-body1 {
        max-width: 756px;
        margin: 0 auto 45px;
    }
    .MuiTextField-root {
        width: 100%;

        &:not(:last-child) {
        margin-bottom: 30px;
        }

        input {
        box-sizing: border-box;
        height: 70px;

        @media (max-width: 599px) {
            height: 50px;
        }
        }

        .MuiInputLabel-root {
        /* transform: translate(14px, 22px) scale(1); */
        color: #65676A;
        font-weight: 400;
        font-size: 16px;
        padding-top: 8px;

        /* @media (max-width: 599px) {
            transform: translate(14px, 14px) scale(1);
        }

        &.Mui-focused {
            transform: translate(14px, -9px) scale(0.75);
        } */
        &.MuiInputLabel-shrink {
        padding-top: 0;
      }
        }

        .Mui-focused {
        .MuiOutlinedInput-notchedOutline {
            border-color: rgba(0, 0, 0, 0.23);
            border-width: 1px;
        }
        }
    }

    .MuiButtonBase-root {
        width: 100%;
        margin-top: 45px;
    }`
const ModalCloseBtn = styled(Button)`
    position: absolute;
    right: 15px;
    top: 15px;
    color: #1E294C;
    margin: 0 !important;
    width: auto !important;
    padding: 0;
    min-width: 1px;

    &:hover {
        background-color: #fff !important;
    }
`
const OurSec = styled(Box)`
  .cmn-head {
    &.dif-head {
      color: white;
    }
  }
  .our-outr {
    text-align: center;
    background: #1e294c;
    border-radius: 20px;
    padding: 75px;
    position: relative;
    @media (max-width:1199px){
      padding: 40px;
      }
    p {
      &.MuiTypography-root {
        color: white;
        max-width: 728px;
        margin: 0 auto;
        position: relative;
        z-index: 2;
      }
    }
    .bluedot {
      position: absolute;
      right: 25px;
      top: 25px;
      @media (max-width:1199px) {
      top: 10px;
      right: 25px;
      width: 100px;
      line-height: 0;
        
      }
    }
    .bluedot2 {
      position: absolute;
      bottom: 25px;
      left: 25px;
      @media (max-width:1199px) {
      bottom: 0;
      top: auto;
      left: 25px;
      width: 100px;
      line-height: 0;
        
      }
    }
  }
`;



export default function About() {
  const listItems = [
    {
      listData: "18+ Years Old",
    },
    {
      listData: "Community Living (CL) Waiver",
    },
    {
      listData: "Diagnosis of Intellectual/Developmental Disability",
    },
  ];

  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Wrapper>
      <Seo title="About" canonical={""} description={""} url={""} image={""} />
      <CommonHeaderInner name={<Box>About <span>Us</span></Box>} pageName="About Us" />
      <AboutSec>
        <Box className="about-sec-main cmn_gap">
          <Box className="about-sec ">
            <Container fixed>
              <Box className="about-outr">
                <Grid container spacing={2} className="about-row">
                  <Grid item xs={12} md={6} className="order2">
                    <Box className="about-inr">
                      <Typography variant="h2" className="cmn-head">
                        We care like family with <span>attention and detail</span>{" "}
                      </Typography>
                      <Typography variant="body1">
                        AAA Residencies was founded in 2019 with one major goal:
                        to provide individuals with intellectual and
                        developmental disabilities the resources, care, and
                        opportunities to become happy, confident, and successful
                        in their lives. All management and team members are
                        driven by a deep desire to positively impact the lives
                        of our community members. We view professionalism,
                        accountability, responsibility, and commitment as just a
                        few requirements of our client’s success. We use the
                        best in class technology and high-quality finishes to
                        make our homes feel as luxury as possible. Our clients
                        receive care and attention 24 hours a day to improve
                        your loved one’s quality and ensure constant growth.
                      </Typography>
                      <Box className="btn-outr">
                        <Link href="mailto:info@aaaresidencies.com">
                          <CustomButton type="button">
                            <Typography variant="button">

                              <Image
                                src={assest.btnimg}
                                alt="btn"
                                width={20}
                                height={20}
                              />Inquire Now
                            </Typography>
                          </CustomButton>
                        </Link>
                      </Box>
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} className="order1">
                    <figure className="about-fig">
                      {/* <Image src={assest.aboutImg1} alt="aboutimg1" width={600} height={500} priority /> */}
                      <Image src={assest.about01} width={547} height={580} layout='responsive' alt="image" />
                    </figure>
                  </Grid>
                </Grid>
                <span className="blackdot">
                  <Image
                    src={assest.bluedot}
                    alt="dot"
                    width={200}
                    height={200}
                  />
                </span>
              </Box>
            </Container>
          </Box>
          <Box className="about-sec">
            <Container fixed>
              <Box className="about-outr">
                <Grid container spacing={2} className="about-row">
                  <Grid item xs={12} md={6} className="order2">
                    <Box className="about-inr">
                      <Typography variant="h2" className="cmn-head">
                        Family owned{" "}
                        <span>and operated</span>{" "}
                      </Typography>
                      <Typography variant="body1">
                        {/* We envision AAA Residencies to be a luxury place where
                        individuals can call home and feel confident, empowered,
                        and accomplished. Care and professionalism are our
                        expertise but growth is what we strive for. */}
                        Our mission is to empower, support, and provide for community members. Our goal is to help them become successful in all aspects of life and be productive members of the community.

                      </Typography>
                      {/* <Box className="btn-outr">
                        <CustomButton type="button" onClick={handleClickOpen}>
                          <Typography variant="button">

                            <Image
                              src={assest.btnimg}
                              alt="btn"
                              width={20}
                              height={20}
                            />Start Now
                          </Typography>
                        </CustomButton>
                      </Box> */}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} className="order1">
                    <figure className="about-fig">
                      {/* <Image
                        src={assest.aboutImg2}
                        alt="aboutimg2"
                        width={600}
                        height={500}
                      /> */}
                      <Image src={assest.about02} width={547} height={580} layout='responsive' alt="image" />
                    </figure>
                  </Grid>
                </Grid>
                <span className="blackdot">
                  <Image
                    src={assest.skydot}
                    alt="dot"
                    width={200}
                    height={200}
                  />
                </span>
              </Box>
            </Container>
          </Box>
        </Box>
      </AboutSec>
      <OurSec>
        <Box className="our-sec">
          <Container fixed>
            <Box className="our-outr">
              <Typography variant="h2" className="cmn-head dif-head">
                Our <span>Mission</span>{" "}
              </Typography>
              <Typography variant="body1">
                {/* Our mission is to empower, support, and provide for community
                members with intellectual and developmental disabilities and
                help them become successful in all aspects of life. */}
                Our mission is to empower, support, and provide for community members. Our goal is to help them become successful in all aspects of life and be productive members of the community.
              </Typography>
              <span className="bluedot">
                <Image
                  src={assest.bluedot2}
                  alt="dot"
                  width={200}
                  height={200}
                />
              </span>
              <span className="bluedot2">
                <Image
                  src={assest.bluedot2}
                  alt="dot"
                  width={200}
                  height={200}
                />
              </span>
            </Box>
          </Container>
        </Box>
      </OurSec>
      <AboutSec>
        <Box className="about-sec-main cmn_gap">
          <Box className="about-sec ">
            <Container fixed>
              <Box className="about-outr">
                <Grid container spacing={2} className="about-row">
                  <Grid item xs={12} md={6} className="order2">
                    <Box className="about-inr">
                      <Typography variant="h2" className="cmn-head">
                        Requirements that <span>need to be met. </span>{" "}
                      </Typography>
                      <List>
                        {listItems.map((item, index) => {
                          return (
                            <ListItem key={index}>
                              <Typography variant="body1" className="list-para">
                                {item.listData}
                              </Typography>
                            </ListItem>
                          );
                        })}
                      </List>
                      {/* <Box className="btn-outr">
                        <CustomButton type="button" onClick={handleClickOpen}>
                          <Typography variant="button">
                            <Image
                              src={assest.btnimg}
                              alt="btn"
                              width={20}
                              height={20}
                            />

                            Start Now
                          </Typography>
                        </CustomButton>
                      </Box> */}
                    </Box>
                  </Grid>
                  <Grid item xs={12} md={6} className="order1">
                    <figure className="about-fig">
                      <Image
                        src={assest.aboutImg3}
                        alt="aboutimg3"
                        width={600}
                        height={500}
                      />
                    </figure>
                  </Grid>
                </Grid>
              </Box>
            </Container>
          </Box>
        </Box>
      </AboutSec>
      <WhatPeopleSay />
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='expDialog'
      >
        <EnqueryDialog>
          <ModalCloseBtn onClick={handleClose}>
            <CancelIcon />
          </ModalCloseBtn>
          <Typography variant="h2" className="cmn-head">
            Get <span>Started</span>
          </Typography>
          {/* <Typography variant="body1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis feugiat sem at dui tempor, ac tristique sapien posuere. Aliquam vel sagittis erat.
          </Typography> */}
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <TextField id="outlined-basic" label="Name" />
                <TextField id="outlined-basic" label="Email" />
                <TextField id="outlined-basic" label="Phone" />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="outlined-multiline-static"
                  label="Message"
                  multiline
                  rows={10.3}
                />
              </Grid>
            </Grid>
          </Box>
          <CustomButton type="button"><Typography variant="button">Start</Typography></CustomButton>
        </EnqueryDialog>
      </Dialog>
    </Wrapper>
  );
}
